import { Swiper } from '@services';
import { N as Navigation } from './navigation-Bm_wcxKy.js';
import './create-element-if-not-defined-CdtEf1Zs.js';
import './utils-BgX2tuHA.js';

class FeaturedCollections extends HTMLElement {
  swiperElement = this.querySelector('.swiper');
  swiperButtonNext = this.querySelector('.swiper-button-next');
  swiperButtonPrev = this.querySelector('.swiper-button-prev');

  connectedCallback() {
    if (!this.swiperElement) return;

    this.initSwiper();
  }

  /**
   * Initializes the swiper instance
   */
  initSwiper() {
    this.swiperInstance = new Swiper(this.swiperElement, {
      modules: [Navigation],
      slidesPerView: 2,
      spaceBetween: 1,
      lazyPreloadPrevNext: 2,
      loop: true,
      navigation: {
        nextEl: this.swiperButtonNext,
        prevEl: this.swiperButtonPrev,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
      },
    });
  }
}

customElements.define('featured-collections', FeaturedCollections);
